import React, { useState } from 'react';
import { CalendarIcon, FilterIcon, PlusIcon, SearchIcon, ChevronLeftIcon, ChevronRightIcon, UsersIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const DutyManagementScreen = () => {
  const [view, setView] = useState('table'); // 'table' or 'calendar'
  const [selectedDate, setSelectedDate] = useState(new Date());
  // Sample duty data
  const duties = [{
    id: 1,
    title: 'Ashara Security - Gate 1',
    date: '2023-08-15',
    time: '08:00 AM - 12:00 PM',
    location: 'Main Markaz',
    members: ['Ahmed Ali', 'Murtaza Husain', 'Yusuf Najmuddin'],
    status: 'Upcoming'
  }, {
    id: 2,
    title: 'Ashara Security - Gate 2',
    date: '2023-08-15',
    time: '12:00 PM - 04:00 PM',
    location: 'Main Markaz',
    members: ['Taher Saifuddin', 'Qasim Hakimuddin'],
    status: 'Upcoming'
  }, {
    id: 3,
    title: 'Eid-ul-Fitr Duty - Entrance',
    date: '2023-08-18',
    time: '07:00 AM - 11:00 AM',
    location: 'Masjid Complex',
    members: ['Hussain Burhanuddin', 'Ali Akbar', 'Mohammed Qutbuddin'],
    status: 'Upcoming'
  }, {
    id: 4,
    title: 'Community Gathering - Security',
    date: '2023-08-10',
    time: '05:00 PM - 09:00 PM',
    location: 'Community Hall',
    members: ['Saifuddin Najam', 'Badruddin Qutbi', 'Shabbir Hakimi'],
    status: 'Completed'
  }, {
    id: 5,
    title: 'Weekly Meeting Security',
    date: '2023-08-05',
    time: '07:00 PM - 09:00 PM',
    location: 'Admin Building',
    members: ['Mufaddal Saifee', 'Hatim Zakir'],
    status: 'Completed'
  }];
  // Calendar data - simplified for this example
  const daysInMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1).getDay();
  const calendarDays = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    calendarDays.push(null); // Empty cells for days before the 1st
  }
  for (let i = 1; i <= daysInMonth; i++) {
    calendarDays.push(i);
  }
  // Get duties for the selected month
  const dutiesThisMonth = duties.filter(duty => {
    const dutyDate = new Date(duty.date);
    return dutyDate.getMonth() === selectedDate.getMonth() && dutyDate.getFullYear() === selectedDate.getFullYear();
  });
  // Function to get duties for a specific day
  const getDutiesForDay = day => {
    if (!day) return [];
    const dateStr = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return duties.filter(duty => duty.date === dateStr);
  };
  // Function to navigate to previous/next month
  const changeMonth = increment => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + increment);
    setSelectedDate(newDate);
  };
  return <div className="space-y-6" data-id="element-175">
      <div className="flex justify-between items-center" data-id="element-176">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-177">Duty Management</h1>
        <button className="bg-blue-800 text-white px-4 py-2 rounded-md flex items-center" data-id="element-178">
          <PlusIcon size={18} className="mr-1" data-id="element-179" />
          Add New Duty
        </button>
      </div>
      {/* Filters and View Toggle */}
      <div className="flex flex-wrap gap-4 items-center justify-between bg-white p-4 rounded-lg shadow" data-id="element-180">
        <div className="flex items-center space-x-4" data-id="element-181">
          <div className="relative" data-id="element-182">
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-183" />
            <input type="text" placeholder="Search duties..." className="pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-184" />
          </div>
          <button className="flex items-center space-x-1 px-3 py-2 border rounded-md hover:bg-gray-50" data-id="element-185">
            <FilterIcon size={18} data-id="element-186" />
            <span data-id="element-187">Filter</span>
          </button>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-188">
            <option data-id="element-189">All Statuses</option>
            <option data-id="element-190">Upcoming</option>
            <option data-id="element-191">In Progress</option>
            <option data-id="element-192">Completed</option>
          </select>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-193">
            <option data-id="element-194">All Locations</option>
            <option data-id="element-195">Main Markaz</option>
            <option data-id="element-196">Masjid Complex</option>
            <option data-id="element-197">Community Hall</option>
            <option data-id="element-198">Admin Building</option>
          </select>
        </div>
        <div className="flex items-center space-x-2" data-id="element-199">
          <span className="text-sm text-gray-500" data-id="element-200">View:</span>
          <div className="flex border rounded-md overflow-hidden" data-id="element-201">
            <button onClick={() => setView('table')} className={`px-3 py-1 ${view === 'table' ? 'bg-blue-800 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`} data-id="element-202">
              Table
            </button>
            <button onClick={() => setView('calendar')} className={`px-3 py-1 flex items-center ${view === 'calendar' ? 'bg-blue-800 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`} data-id="element-203">
              <CalendarIcon size={16} className="mr-1" data-id="element-204" />
              Calendar
            </button>
          </div>
        </div>
      </div>
      {/* Table View */}
      {view === 'table' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-205">
          <div className="overflow-x-auto" data-id="element-206">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-207">
              <thead className="bg-gray-50" data-id="element-208">
                <tr data-id="element-209">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-210">
                    Duty Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-211">
                    Date & Time
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-212">
                    Location
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-213">
                    Members
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-214">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-215">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-216">
                {duties.map(duty => <tr key={duty.id} className="hover:bg-gray-50" data-id="element-217">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-218">
                      <div className="text-sm font-medium text-gray-900" data-id="element-219">
                        {duty.title}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-220">
                      <div className="text-sm text-gray-900" data-id="element-221">{duty.date}</div>
                      <div className="text-sm text-gray-500" data-id="element-222">{duty.time}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-223">
                      <div className="text-sm text-gray-900" data-id="element-224">
                        {duty.location}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-225">
                      <div className="flex -space-x-2" data-id="element-226">
                        {duty.members.slice(0, 3).map((member, idx) => <div key={idx} className="w-8 h-8 rounded-full bg-blue-600 border-2 border-white flex items-center justify-center text-white text-xs" data-id="element-227">
                            {member.charAt(0)}
                          </div>)}
                        {duty.members.length > 3 && <div className="w-8 h-8 rounded-full bg-gray-300 border-2 border-white flex items-center justify-center text-gray-700 text-xs" data-id="element-228">
                            +{duty.members.length - 3}
                          </div>}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-229">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${duty.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-230">
                        {duty.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-231">
                      <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-232">
                        Edit
                      </button>
                      <button className="text-red-600 hover:text-red-900" data-id="element-233">
                        Delete
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="bg-white px-4 py-3 flex items-center justify-between border-t" data-id="element-234">
            <div className="flex-1 flex justify-between sm:hidden" data-id="element-235">
              <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-236">
                Previous
              </button>
              <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-237">
                Next
              </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-238">
              <div data-id="element-239">
                <p className="text-sm text-gray-700" data-id="element-240">
                  Showing <span className="font-medium" data-id="element-241">1</span> to{' '}
                  <span className="font-medium" data-id="element-242">5</span> of{' '}
                  <span className="font-medium" data-id="element-243">12</span> duties
                </p>
              </div>
              <div data-id="element-244">
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-245">
                  <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-246">
                    <span className="sr-only" data-id="element-247">Previous</span>
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-248" />
                  </button>
                  <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-249">
                    1
                  </button>
                  <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-800 text-sm font-medium text-white" data-id="element-250">
                    2
                  </button>
                  <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-251">
                    3
                  </button>
                  <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-252">
                    ...
                  </span>
                  <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-253">
                    8
                  </button>
                  <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-254">
                    <span className="sr-only" data-id="element-255">Next</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-256" />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>}
      {/* Calendar View */}
      {view === 'calendar' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-257">
          <div className="p-4 flex items-center justify-between border-b" data-id="element-258">
            <div className="flex items-center" data-id="element-259">
              <button onClick={() => changeMonth(-1)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-260">
                <ChevronLeftIcon size={20} data-id="element-261" />
              </button>
              <h2 className="text-lg font-semibold mx-4" data-id="element-262">
                {selectedDate.toLocaleString('default', {
              month: 'long',
              year: 'numeric'
            })}
              </h2>
              <button onClick={() => changeMonth(1)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-263">
                <ChevronRightIcon size={20} data-id="element-264" />
              </button>
            </div>
            <div className="text-sm text-gray-500" data-id="element-265">
              Drag and drop to reassign duties
            </div>
          </div>
          <div className="grid grid-cols-7 gap-px bg-gray-200" data-id="element-266">
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, idx) => <div key={idx} className="bg-gray-50 text-center py-2 text-sm font-medium text-gray-500" data-id="element-267">
                  {day}
                </div>)}
            {calendarDays.map((day, idx) => {
          const dayDuties = getDutiesForDay(day);
          return <div key={idx} className={`bg-white min-h-[120px] p-1 ${day ? 'cursor-pointer hover:bg-gray-50' : ''}`} data-id="element-268">
                  {day && <>
                      <div className={`text-right p-1 ${new Date().getDate() === day && new Date().getMonth() === selectedDate.getMonth() && new Date().getFullYear() === selectedDate.getFullYear() ? 'bg-blue-100 text-blue-800 rounded-full w-7 h-7 ml-auto flex items-center justify-center' : 'text-gray-500'}`} data-id="element-269">
                        {day}
                      </div>
                      <div className="space-y-1 mt-1" data-id="element-270">
                        {dayDuties.map((duty, dutyIdx) => <div key={dutyIdx} className="text-xs p-1 rounded bg-blue-100 text-blue-800 truncate" title={duty.title} data-id="element-271">
                            {duty.title.length > 20 ? duty.title.substring(0, 18) + '...' : duty.title}
                          </div>)}
                      </div>
                    </>}
                </div>;
        })}
          </div>
        </div>}
      {/* Duty Details Panel - Would typically be shown when a duty is selected */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-272">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-273">
          Duty Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-274">
          <div data-id="element-275">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-276">
              Ashara Security - Gate 1
            </h3>
            <div className="space-y-3 mt-4" data-id="element-277">
              <div className="flex items-center text-gray-600" data-id="element-278">
                <CalendarIcon size={18} className="mr-2" data-id="element-279" />
                <span data-id="element-280">August 15, 2023</span>
              </div>
              <div className="flex items-center text-gray-600" data-id="element-281">
                <ClockIcon size={18} className="mr-2" data-id="element-282" />
                <span data-id="element-283">08:00 AM - 12:00 PM</span>
              </div>
              <div className="flex items-center text-gray-600" data-id="element-284">
                <MapPinIcon size={18} className="mr-2" data-id="element-285" />
                <span data-id="element-286">Main Markaz, Gate 1</span>
              </div>
              <div className="flex items-center text-gray-600" data-id="element-287">
                <UsersIcon size={18} className="mr-2" data-id="element-288" />
                <span data-id="element-289">3 Members Assigned</span>
              </div>
            </div>
            <div className="mt-6" data-id="element-290">
              <h4 className="font-medium text-gray-700 mb-2" data-id="element-291">Description</h4>
              <p className="text-gray-600" data-id="element-292">
                Security duty at Gate 1 during Ashara Mubaraka. Responsibilities
                include checking entry passes, managing crowd flow, and ensuring
                only authorized personnel enter through this gate.
              </p>
            </div>
          </div>
          <div data-id="element-293">
            <h4 className="font-medium text-gray-700 mb-3" data-id="element-294">Assigned Members</h4>
            <div className="space-y-3" data-id="element-295">
              {['Ahmed Ali', 'Murtaza Husain', 'Yusuf Najmuddin'].map((member, idx) => <div key={idx} className="flex items-center justify-between p-3 border rounded-lg" data-id="element-296">
                    <div className="flex items-center" data-id="element-297">
                      <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-medium mr-3" data-id="element-298">
                        {member.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div data-id="element-299">
                        <div className="font-medium" data-id="element-300">{member}</div>
                        <div className="text-sm text-gray-500" data-id="element-301">
                          Guard Level 2
                        </div>
                      </div>
                    </div>
                    <button className="text-red-600 hover:text-red-800" data-id="element-302">
                      Remove
                    </button>
                  </div>)}
              <button className="w-full p-2 border border-dashed rounded-lg text-blue-600 hover:bg-blue-50 flex items-center justify-center" data-id="element-303">
                <PlusIcon size={18} className="mr-1" data-id="element-304" />
                Add Member
              </button>
            </div>
            <div className="mt-6 flex space-x-3" data-id="element-305">
              <button className="flex-1 bg-blue-800 text-white py-2 rounded-md hover:bg-blue-700" data-id="element-306">
                Edit Duty
              </button>
              <button className="flex-1 border border-red-600 text-red-600 py-2 rounded-md hover:bg-red-50" data-id="element-307">
                Cancel Duty
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default DutyManagementScreen;